import { getRequest, postRequest, postRequestBlob, severityCode } from "./httpClient";

const END_POINT = "locationlabel";

const getLocationLabels = async (partyReference : string, currentPage : number, pageSize : number, sortBy : string, sortDesc : string, filterData : any) => {
  return postRequest(`${END_POINT}/${partyReference}/list`, { filterData: filterData }, { pageNumber: currentPage, pageSize: pageSize, sortBy: sortBy, sortDesc: sortDesc });
};

const getLocationLabelFilterOptions = async (partyReference : string, fieldName : string, text : string, filterData : any) => {
  return postRequest(`${END_POINT}/${partyReference}/autoComplete/${fieldName}`, { filterData: filterData }, { text: text });
};

const getDocumentIds = async (type: string, locationReference: string, registrationNumber: string) => {
  const response = await getRequest(`${END_POINT}/${locationReference}/documentIds`, { type: type, documentNumber: registrationNumber });
  return response.data;
};

const getDocumentFileById = async (documentId: string) => {
  const response = await getRequest(`${END_POINT}/document/${documentId}`);
  return response;
};

const getLabelDocuments = async (partyReference: number, filterData: any) => {
  const response = await postRequestBlob(`${END_POINT}/${partyReference}/documents`, { filterData: filterData });
  return response;
};

export { getLocationLabels, getLocationLabelFilterOptions, getDocumentIds, getDocumentFileById, getLabelDocuments, severityCode };
